import MemberIndexPage from "../components/pages/member-management/MemberIndexPage.vue";
import MemberCreatePage from "../components/pages/member-management/MemberCreatePage.vue";
import MemberEditPage from "../components/pages/member-management/MemberEditPage.vue";
import MemberEditRolePage from "../components/pages/member-management/MemberEditRolePage.vue";
import MemberIdentityVerification from "../components/pages/member-management/MemberIdentityVerification.vue";
import MemberIdentityVerificationInfo from "../components/pages/member-management/MemberIdentityVerificationInfo.vue";
import StudentInfoReport from "../components/pages/member-management/StudentInfoReport.vue";

import GroupIndexPage from "../components/pages/member-group-management/IndexPage";
import GroupCreatePage from "../components/pages/member-group-management/CreatePage";
import GroupEditPage from "../components/pages/member-group-management/EditPage";

import VerifyMemberFacePage from "../components/pages/member-management/VerifyMemberFacePage";

import MemberFaceApprove from "../components/pages/member-management/MemberFaceApprovePage";

import FaceApproveSearchHistory from "../components/pages/member-management/FaceApproveSearchHistoryPage";

import FaceApproveSearchHistoryDetails from "../components/pages/member-management/FaceApproveSearchHistoryDetails"

import AbnormalUsagePage from "../components/pages/member-management/AbnormalUsagePage.vue";
import WannasornUserManagementPage from "../components/pages/member-management/WannasornUserManagementPage.vue";
import LearningFaceMonitoringPage from "../components/pages/member-management/LearningFaceMonitoringPage.vue";

export default [
  /** Member management */
  {
    path: "members",
    name: "member.index",
    component: MemberIndexPage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["read-member", "crud-member"],
    },
  },
  {
    path: "member/identity-verification",
    name: "member.identity-verification",
    component: MemberIdentityVerification,
    meta: {
      access: { menu: "user", subMenu: "member-identity-verification" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
  {
    path: "member/:memberId/identity-verification-info",
    name: "member.identity-verification-info",
    component: MemberIdentityVerificationInfo,
    meta: {
      access: { menu: "user", subMenu: "member-identity-verification" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
  {
    path: "member/add",
    name: "member.create",
    component: MemberCreatePage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
  {
    path: "member/:id/edit",
    name: "member.edit",
    component: MemberEditPage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
  {
    path: "members/face-verification",
    name: "members.face-verification.index",
    component: VerifyMemberFacePage,
    meta: {
      access: { menu: "user", subMenu: "member-face-learning-verification" },
      authRequired: true,
      permsRequired: ["crud-member", "read-member"],
    },
  },

  {
    path: "members/role",
    name: "members.role",
    component: MemberEditRolePage,
    meta: {
      access: { menu: "user", subMenu: "admin-mgmt" },
      authRequired: true,
      permsRequired: ["read-member", "crud-member"],
    },
  },

  /** Member-group management */
  {
    path: "groups",
    name: "group.index",
    component: GroupIndexPage,
    meta: {
      access: { menu: "user", subMenu: "user-group-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member-group"],
    },
  },

  {
    path: "groups/create",
    name: "group.create",
    component: GroupCreatePage,
    meta: {
      access: { menu: "user", subMenu: "user-group-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member-group"],
    },
  },

  {
    path: "groups/:id",
    name: "group.edit",
    component: GroupEditPage,
    meta: {
      access: { menu: "user", subMenu: "user-group-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member-group"],
    },
  },

  {
    path: "members/face-verification/face-approve/:cerId/courses/:cId",
    name: "members.face-verification.face-approve.courses",
    component: MemberFaceApprove,
    meta: {
      access: { menu: "user", subMenu: "member-face-learning-verification" },
      template: "A",
    },
  },

  {
    path: "members/face-approve-search-history",
    name: "members.face-approve-search-history",
    component: FaceApproveSearchHistory,
    meta: {
      access: { menu: "user", subMenu: "member-face-learning-verification" },
      template: "A",
    },
  },

  {
    path: "members/face-approve-search-history/:fashId/courses/:cId",
    name: "members.face-approve-search-history.details",
    component: FaceApproveSearchHistoryDetails,
    meta: {
      access: { menu: "user", subMenu: "member-face-learning-verification" },
      template: "A",
    },
  },

  {
    path: "members/abnormal-usage",
    name: "members.abnormal-usage",
    component: AbnormalUsagePage,
    meta: {
      access: { menu: "user", subMenu: "abnormal-usage-log" },
      authRequired: true,
    },
  },
  {
    path: "members/:mId/learning-face",
    name: "members.learning-face",
    component: LearningFaceMonitoringPage,
    meta: {
      access: { menu: "user", subMenu: "learning-face-monitoring" },
      authRequired: true,
    },
  },

  {
    path: "members/student-info-report",
    name: "members.student-info-report",
    component: StudentInfoReport,
    meta: {
      authRequired: true,
      permsRequired: ["crud-member", "read-member"],
    },
  },

  {
    path: "members/wannasorn-role",
    name: "members.wannasorn-role",
    component: WannasornUserManagementPage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["read-member", "crud-member"],
    },
  },
];
